module.exports = "<div\n  *ngIf=\"label\"\n  class=\"tex-area-label\">\n  {{label}}\n</div>\n<textarea\n  [id]=\"id\"\n  [placeholder]=\"placeholder\"\n  [maxLength]=\"maxLength\"\n  [ngClass]=\"isError ? 'input-error' : ''\"\n  (keyup)=\"onKeyup($event)\"\n  (keydown.space)=\"onKeySpace($event)\"\n  (focusout)=\"onFocusOut($event)\">\n</textarea>\n<span\n  *ngIf=\"isError && errorText\"\n  class=\"text-error mt-0\">\n  {{errorText}}\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/act-text-area/act-text-area.component.html
// module id = 1005
// module chunks = 22